import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Radio,
  Checkbox,
  Collapse,
  notification,
  Divider,
  Card,
  Upload,
  message
} from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { UploadOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import _ from "lodash";

import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { pacienteCreateAction, pacienteReadAction } from '../../../redux/clinica/pacientes/actionCreator';
import {
  estadosListAction,
  municipioListAction,
} from '../../../redux/catalogos/actionCreator';
import { sucursalListAction } from '../../../redux/administracion/sucursales/actionCreator';

const dateFormat = 'YYYY-MM-DD';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT + '/pacientes/fileUpload.php';

const PacienteMainForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const catalogoEstados = useSelector(state => state.CatalogosReducer.estados);
  const catalogoMunicipios = useSelector(state => state.CatalogosReducer.municipios);
  const catalogoSucursales = useSelector(state => state.SucursalReducer.dataSelectBox);
  const catalogoTipoOrigenes = useSelector(state => state.CatalogosReducer.tipoOrigenes);
  const catalogoGeneros = useSelector(state => state.CatalogosReducer.generos);
  const catalogoEstadosCivil = useSelector(state => state.CatalogosReducer.estadosCivil);
  const catalogoRegimenFiscal = useSelector(state => state.CatalogosReducer.regimenFiscal);
  const registro = useSelector(state => state.PacienteReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();
  const [form] = Form.useForm();
  useEffect(() => {
    dispatch(estadosListAction());
    dispatch(sucursalListAction());
  }, []);

  useEffect(() => {
    // console.log('pacienteId: ', id);
    if (id) dispatch(pacienteReadAction(id));
    else {
      dispatch(pacienteReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      loadCatalogoMunicipios(registro.idEstado);
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const loadCatalogoMunicipios = idEstado => {
    if (municipioListAction) {
      dispatch(municipioListAction(idEstado));
    }
  };

  const handleSubmit = async values => {
    let action = 'create';
    if (id) {
      action = 'update';
    }
    console.log("values:", values);
    const responseApi = await dispatch(
      pacienteCreateAction({
        ...values,
        action: action,
      }),
    );
    if (responseApi) {
      let mensaje = 'Paciente creado exitosamente';
      if (action === 'update') mensaje = 'Paciente actualizado exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      if (action === "create")
        history.replace(`/admin/clinica/pacientes/expediente/presupuesto/${responseApi?.id}`);
      else

        history.replace('/admin/clinica/pacientes/listado');
    } else {
      notification.error({
        message: 'Error al crear paciente',
      });
    }
  };

  const uploadProps = {
    action: API_ENDPOINT,
    accept: ".doc,.docx,.pdf,.png,.jpg,.jpeg",
    showUploadList: false,
    headers: {
      Authorization: `Bearer ${Cookies.get('dcare_access_token')}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} archivo subido correctamente`);
        dispatch(pacienteReadAction(id));
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} error al subir el archivo`);
      }
    },
  };

  const showFile = (identificador) => {

    //console.log("registro.documentos: ", registro.documentos);
    let archivo = _.find(registro.documentos, function (o) { return o.identificador === identificador; });    
    let linkToFile = (<><p>Aún no hay archivo</p></>);
    if (archivo) {
      linkToFile = (<p>
        <a href={archivo.url} target='_blank'><DownloadOutlined /> Descargar archivo</a>

      </p>)
    }
    return linkToFile
  };

  return (
    <>

      <Card size="small">
        <Form
          layout="vertical"
          size="small"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="idTipoOrigen"
                label="Origen"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select placeholder="Origen" options={catalogoTipoOrigenes} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="idSucursalOrigen" label="Sucursal de orígen" rules={[{ message: 'Campo obligatorio', required: true }]}>
                <Select placeholder="* Sucursal de orígen" options={catalogoSucursales} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>

              {/*<Form.Item
                name="folio"
                noStyle
              >
                <Input placeholder="Folio de membresia" style={{ width: '220px', margin: '0 7px' }} />
              </Form.Item>
  */}
              <Form.Item
                name="folio_historico"
                label="Folio historico"
              >
                <Input style={{ width: '250px' }} />
              </Form.Item>

            </Input.Group>
          </Form.Item>


          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="nombre"
                label="Nombre(s)"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="paterno"
                label="Apellido paterno"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="materno"
                label="Apellido materno"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="genero"
                label="Genero"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select placeholder="Selecciona" options={catalogoGeneros} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="fecha_nacimiento" label="Fecha de nacimiento (dd-mm-yyyy)" rules={[{ required: false }, {
                pattern: /^\d{2}-\d{2}-\d{4}$/,
                message: 'Escríbe la fecha en el formato indicado',
              },]} >
                <Input placeholder='Ej. 02-28-1980' style={{ width: '250px' }} />

              </Form.Item>
            </Input.Group>
          </Form.Item>


          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="telefono_movil"
                label="Teléfono móvil"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input placeholder="ddd" style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="telefono_particular"
                label="Teléfono particular">
                <Input style={{ width: '200px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="telefono_laboral"
                label="Teléfono laboral"
              >
                <Input style={{ width: '200px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="email"
                label="Correo electrónico"
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item>
            <Input.Group compact>
              <Form.Item name="calle" label="Calle" rules={[{ required: false }]}>
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="numero" label="Número" rules={[{ required: false }]}>
                <Input style={{ width: '200px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="colonia" label="Colonia" rules={[{ message: 'Campo obligatorio', required: true }]}>
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="codigo_postal" label="Código postal" rules={[{ required: false }]}>
                <Input placeholder="Código postal" style={{ width: '150px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="idEstado"
                label="Estado"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select
                  options={catalogoEstados}
                  onSelect={e => loadCatalogoMunicipios(e)}
                  notFoundContent={'Sin registros'}
                  style={{ width: '245px', margin: '0 7px' }}
                />
              </Form.Item>
              <Form.Item
                name="idMunicipio"
                label="Municipio"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select
                  options={catalogoMunicipios}
                  notFoundContent={'Selecciona un estado'}
                  style={{ width: '245px' }}
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="estado_civil"
                label="Estado civil"
              >
                <Select options={catalogoEstadosCivil} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="ocupacion"
                label="Ocupación"
              >
                <Input style={{ width: '300px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="rfc"
                label="RFC"
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="razon_social"
                label="Razón social"
              >
                <Input style={{ width: '400px', margin: '0 7px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="regimen_fiscal"
                label="Regimen fiscal"
              >
                <Select placeholder="Selecciona..." options={catalogoRegimenFiscal} notFoundContent={'Sin registros'} style={{ width: '500px', margin: '0 12px' }} />
              </Form.Item>
              <Form.Item name="codigo_postal_fiscal" label="Código postal fiscal" rules={[{ required: false }]}>
                <Input style={{ width: '150px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item name="idEstatus" label="Estatus de la cuenta" rules={[{ message: 'Campo obligatorio', required: true }]}>
            <Radio.Group>
              <Radio value="1">
                Paciente activo
              </Radio>
              <Radio value="2">
                Paciente suspendido
              </Radio>
              <Radio value="3">
                Paciente dado de baja
              </Radio>
            </Radio.Group>
          </Form.Item>

          <br />
          <div className="record-form-actions text-right">
            <Button size="default" htmlType="Save" type="primary">
              {isLoading ? 'Cargando...' : 'Guardar'}
            </Button>
          </div>

          <Form.Item name="id" initialValue="0">
            <Input hidden />
          </Form.Item>
          <Form.Item name="idConvenio" initialValue="0">
            <Input hidden />
          </Form.Item>

        </Form>
      </Card>
      <RecordFormWrapper>
        <Cards headless>
          <p><strong>Foto de la ficha de datos firmada por el paciente</strong></p>
          <Row gutter={24}>
            <Col lg={6}>
              {showFile('ficha_datos_paciente')}
            </Col>
            <Col>
              <Upload name='ficha_datos_paciente' data={{ pacienteId: id, nombreArchivo: 'ficha_datos_paciente' }}  {...uploadProps}>

                <Button icon={<UploadOutlined />}>Subir archivo</Button>
              </Upload>
            </Col>
          </Row>
        </Cards>
      </RecordFormWrapper>
    </>
  );
};

export default PacienteMainForm;
